import { cn } from '@/lib/utils';
import type { ApartmentCardMetadataInput } from './apartment-card-utils';
import { getApartmentCardMetadata } from './apartment-card-utils';

interface ApartmentCardMetaLineProps extends ApartmentCardMetadataInput {
  className?: string;
}

export default function ApartmentCardMetaLine({
  className,
  ...metadata
}: ApartmentCardMetaLineProps) {
  return (
    <p
      className={cn(
        'mt-2 border-t border-[#E8E1D4] pt-2 text-center text-[13px] leading-relaxed text-gray-600',
        className
      )}
    >
      {getApartmentCardMetadata(metadata)}
    </p>
  );
}
